<template>
  <AppSmartList
    ref="app-smart-list"
    :breadcrumbData="breadcrumbData"
    :accessRights="accessRights"
    :filters="filters"
    :actions="actions"
    :tableHeaders="headers"
  >
  </AppSmartList>
</template>

<script>
import AppSmartList from "@/views/components/bases/smart/AppSmartList.vue";
import commonMixin from "@/core/mixins/common.mixin";
import { i18nHelper } from "@/core/utils";
import { ROUTE_NAME } from "@/core/constants";
import {
  HOME_GET_APPS,
  HOME_INITIAL_GET_APPS_STATE,
} from "@/core/store/home.module";

export default {
  name: "home",
  components: {
    AppSmartList,
  },
  mixins: [commonMixin],
  data: () => ({
    breadcrumbData: {
      breadcrumbs: [],
    },
    actions: {
      viewList: {
        module: "home",
        state: "apps",
        action: HOME_GET_APPS,
        initialStateAction: HOME_INITIAL_GET_APPS_STATE,
        title: i18nHelper.getMessage("label.getApps"),
      },
    },
    accessRights: {},
    filters: [
      {
        label: "appName",
        key: "appName",
      },
    ],
    headers: [
      {
        key: "publicHybrid",
        name: "publicHybrid",
        headerStyle: "width:250px;",
        //sortable: true,
      },
      {
        key: "businessUnit",
        name: "businessUnit",
        //sortable: true,
      },
      {
        key: "appName",
        name: "appName",
        //sortable: true,
      },
      {
        key: "accountName",
        name: "accountName",
        //sortable: true,
      },
      {
        key: "createUser",
        name: "createUser",
        //sortable: true,
      },
      {
        key: "createTime",
        name: "createTime",
        //sortable: true,
      },
      {
        key: "status",
        name: "status",
        //sortable: true,
        layout: "HomeStatusLabel",
      },
      {
        key: "argoURL",
        name: "argoUrl",
        headerStyle: "width:100px;",
        active: true,
        layout: "AppTableActions",
        layoutActions: {
          openUrl: true,
        },
      },
    ],
  }),
  mounted() {},
  computed: {},
  watch: {},
  methods: {},
};
</script>

<style></style>
